module.exports = __webpack_public_path__ + "media/customizations/mayfairtxlife/back-3260a316262f6b312e7432777de01703.jpg";